"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/interface-name-prefix, @typescript-eslint/no-unused-vars */
var AnalyticsClientError = /** @class */ (function (_super) {
    __extends(AnalyticsClientError, _super);
    function AnalyticsClientError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AnalyticsClientError;
}(Error));
var BaseClient = /** @class */ (function () {
    function BaseClient(name, config) {
        var _this = this;
        this.trackConversion = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.methodDoesntExist('trackConversion');
        };
        this.trackEvent = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.methodDoesntExist('trackEvent');
        };
        this.trackUser = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.methodDoesntExist('trackUser');
        };
        this.trackException = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.methodDoesntExist('trackException');
        };
        this.trackMetric = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.methodDoesntExist('trackMetric');
        };
        this.methodDoesntExist = function (name) {
            if (process.env.NODE_ENV === 'production') {
                return null;
            }
            throw new AnalyticsClientError(name + " not implemented");
        };
        this.name = name;
        this.config = config;
    }
    return BaseClient;
}());
exports.default = BaseClient;
